module.exports = __webpack_public_path__ + "static/media/1022697.e1a1a118.jpg";